<template lang="pug">
  .b2b-table-delivery-notes-emit
    //- Filtro Tabla Albaranes Emitidos
    b2b-filters-delivery-notes-emit(
      :filter-options='options')

    //- Tabla de Albaranes Emitidos
    ods-table(
      :data='deliveryNotesEmit.tableData',
      :start-sort='{ prop: "creationDateTime", order: "descending"}',
      style='width: 100%',
      @sort-change="orderOnServer",
      @cell-mouse-enter='handleCellMouseEnter',
      @selection-change='handleSelectionChange',
      highlight-current-row,
      size='small',
      fit)
      ods-table-column(
        type='selection',
        width='55')
      ods-table-column(
        prop='buyerName',
        :label='$t("deliverynote.delivery_entity_table.buyer")',
        :show-overflow-tooltip='true',
        v-if='isShowBuyerDeliveryNoteEmit',
        sortable='')
      //- centreBuyer oculta por defecto
      ods-table-column(
        prop='centreBuyer',
        :label='$t("deliverynote.delivery_entity_table.buyer_centre")',
        v-if='isShowCentroCompradorDeliveryNoteEmit && canViewDistributionCentres',
        sortable='')
        template(slot-scope='scope')
          ods-tooltip(placement='top-end')
            template(slot='content')
              | {{ scope.row.centreBuyer }}
              br
              | {{ scope.row.centreBuyerTooltip }}
            div.text-overflow-tooltip
              | {{ scope.row.centreBuyer }}
      ods-table-column(
        prop='centreBuyerDeliveryPoint',
        :label='$t("deliverynote.delivery_entity_table.delivery_centre")',
        v-if='isShowCentroEntregaDeliveryNoteEmit && canViewDistributionCentres',
        sortable='')
        template(slot-scope='scope')
          ods-tooltip(placement='top-end')
            template(slot='content')
              | {{ scope.row.centreBuyerDeliveryPoint }}
              br
              | {{ scope.row.centreBuyerDeliveryPointTooltip }}
            div.text-overflow-tooltip
              | {{ scope.row.centreBuyerDeliveryPoint }}
      ods-table-column(
        prop='sellerName',
        :label='$t("deliverynote.delivery_entity_table.seller")',
        :show-overflow-tooltip='true',
        v-if='isShowSellerDeliveryNoteEmit',
        sortable='')
      //- centreSeller oculta por defecto
      ods-table-column(
        prop='centreSeller',
        :label='$t("deliverynote.delivery_entity_table.seller_centre")',
        v-if='isShowCentroVendedorDeliveryNoteEmit',
        sortable='')
        template(slot-scope='scope')
          ods-tooltip(placement='top-end')
            template(slot='content')
              | {{ scope.row.centreSeller }}
              br
              | {{ scope.row.centreSellerTooltip }}
            div.text-overflow-tooltip
              | {{ scope.row.centreSeller }}
      ods-table-column(width='150',
        prop='deliveryNumber',
        :label='$t("deliverynote.delivery_entity_table.num_deliverynote")',
        :show-overflow-tooltip='true',
        v-if='isShowNumDeliveryNoteEmit',
        sortable='')
      ods-table-column(
        prop='issueDateTime',
        :label='$t("deliverynote.delivery_entity_table.date_issue")',
        align='center',
        :show-overflow-tooltip='true',
        v-if='isShowDateIssueDeliveryNoteEmit',
        :formatter="formatterDate",
        sortable='')
      ods-table-column(
        prop='creationDateTime',
        :label='$t("invoices.invoices_entity_table.creation_date")',
        align='center',
        :show-overflow-tooltip='true',
        v-if='isShowDateCreationDeliveryNoteEmit',
        :formatter='formatterDate',
        sortable='')
      ods-table-column(
        prop='deliveryDate',
        :label='$t("deliverynote.delivery_entity_table.delivery_date")',
        align='center',
        :show-overflow-tooltip='true',
        v-if='isShowDeliveryDateDeliveryNoteEmit',
        :formatter="formatterDate",
        sortable='')
      ods-table-column(
        prop='status',
        :label='$t("deliverynote.delivery_entity_table.status")',
        v-if='isShowStatusDeliveryNoteEmit',
        sortable='')
        template(slot-scope='scope')
          ods-tooltip(placement='top')
            template(slot='content')
              | {{ formatterTooltipInvoiceStatus(scope.row, scope.column) }}
            div.text-overflow-tooltip
              | {{ formatterInvoiceStatus(scope.row, scope.column) }}
      //- Ocultas por defecto
      ods-table-column(
        prop='projectName',
        :label='$t("deliverynote.delivery_entity_table.services")',
        :show-overflow-tooltip='true',
        v-if='isShowServiceDeliveryNoteEmit',
        sortable='')
      ods-table-column(
        label,
        :render-header='renderHeaderActions',
        width='120')
        template(slot-scope='scope' placement='center')
          ods-tooltip(placement='left')
            template(slot='content')
              | {{ $t('deliverynote.deliverynote_detail.download_pdf_buttons_tooltip') }}
            ods-button(
              style=' padding-left: 0px; padding-right: 0px;'
              type='neutral',
              icon-position='left'
              @click="handleDownloadDeliveryNotePdf(scope.row)")
              ods-icon(name='download', size='16')
          ods-tooltip(placement='left')
            template(slot='content')
              | {{ $t('invoices.tooltip.detail') }}
            ods-button(
              style=' padding-left: 0px; padding-right: 0px;'
              type='neutral',
              @click='handleGoDetail(scope.row)')
              ods-icon(name='search', size='16')
          ods-popover(
          placement="bottom-end"
          trigger="hover"
          v-if='(scope.row.pathDeliveryNoteOriginal != null && canViewDesadvOriginal) || (scope.row.pathDeliveryMetadata && canViewDesadvMetadata) || (canCreateInvoiceDeliveryNote && scope.row.status !== "REJECTED" && scope.row.status !== "ERROR" && scope.row.status !== "FULLY_INVOICED" && scope.row.status !== "PENDING_OF_SEND" && scope.row.idBuyer && scope.row.documentFormatName !== "DIGITALIZED_DELIVERYNOTE") || (scope.row.status === "PENDING_OF_SEND") || (scope.row.hasLabels)')
            ul.__quick-accions
              li
                ods-button(
                  v-if="scope.row.pathDeliveryNoteOriginal != null && canViewDesadvOriginal"
                  icon='ods-icon-download'
                  icon-position='left'
                  @click.native='handleDownloadOriginal(scope.row)' type='neutral' style=' padding-left: 0px; padding-right: 0px;')
                  span {{ $t('invoice_detail.buttons.download_original_signed_tooltip')}}
              li
                ods-button(
                  v-if="scope.row.pathDeliveryMetadata && canViewDesadvMetadata"
                  icon='ods-icon-file'
                  icon-position='left'
                  @click.native="handleDownloadMetadata(scope.row)" type='neutral' style=' padding-left: 0px; padding-right: 0px;')
                  span {{ $t('buttons.btnViewMetadata')}}
              li
                ods-button(
                  v-if='(scope.row.hasLabels)',
                  icon='ods-icon-deliver'
                  icon-position='left'
                  @click.native="handleDownloadLabels(scope.row)" type='neutral' style=' padding-left: 0px; padding-right: 0px;')
                  span {{ $t('buttons.btnDownloadLabels')}}
              li
                ods-button(
                  v-if='(canCreateInvoiceDeliveryNote && scope.row.status !== "REJECTED" && scope.row.status !== "ERROR" && scope.row.status !== "FULLY_INVOICED" && scope.row.status !== "PENDING_OF_SEND" && scope.row.idBuyer && scope.row.documentFormatName !== "DIGITALIZED_DELIVERYNOTE")',
                  icon='ods-icon-plus'
                  icon-position='left'
                  @click.native="handleCreateInvoice(scope.row)" type='neutral' style=' padding-left: 0px; padding-right: 0px;')
                  span {{ $t('recadv.recadv_detail.create_invoice_buttons_tooltip')}}
              li
                ods-button(
                  v-if='(scope.row.status === "PENDING_OF_SEND")',
                  icon='ods-icon-delete'
                  icon-position='left'
                  @click.native="handleDelete(scope.row)" type='neutral' style=' padding-left: 0px; padding-right: 0px;')
                  span {{ $t('new_deliveryNote.new_deliveryNote_form.notify.delete_tooltip')}}
            ods-button(
              style='padding-left: 0px; padding-right: 0px;'
              slot="reference",
              icon-position='left'
              type='neutral')
              ods-icon(name='overflow-menu', size='16')
    ods-row.b2b-table-delivery-notes-emit__pagination(v-if='deliveryNotesEmit.totalDeliveryNotesEmit > 0')
      ods-col.b2b-table-delivery-notes-emit__pagination--left(:span='1')
        ods-tooltip(:content='$t("invoices.buttons.download_csv_tooltip")', placement='bottom')
          ods-button(
            type='primary',
            size='mini',
            round='',
            icon='ods-icon-download'
            style='display:inline;'
            @click='handleDownloadAllCsvEmitted')
            | CSV
      ods-col.b2b-table-delivery-notes-emit__pagination--left(:span='3')
        ods-tooltip(:content='$t("invoices.buttons.download_csv_details_tooltip")', placement='bottom')
          ods-button(
            type='primary',
            size='mini',
            round,
            icon='ods-icon-download'
            style='display:inline;'
            @click='handleDownloadCsvDetails')
            | {{ $t('invoices.buttons.download_csv_details') }}
      //- Paginación Tabla
      ods-col.b2b-table-delivery-notes-emit__pagination--right(:span='19', style='margin-left: 20px',)
        div.block(style='margin-bottom: 50px;')
          ods-pagination(
            ref='pagination',
            popper-class='b2b-pagination__dropdown',
            @size-change='handleSizeChange',
            @current-change='handleCurrentChangePagination',
            :current-page.sync='currentPage',
            :page-sizes='[20, 50, 100]',
            :page-size='20',
            layout='total, sizes, prev, pager, next, slot',
            :total='deliveryNotesEmit.totalDeliveryNotesEmit')

    //- Albaranes Emitidos Seleccionadas
    transition(
      name='slide',
      mode='out-in')
      b2b-table-select-rows(
        v-if='multipleSelection.length',
        :total-select='multipleSelection.length')
        div(slot='actions')
          ods-tooltip(:content='$t("invoices.buttons.download_invoices_tooltip")', placement='bottom')
            ods-button(
              icon='ods-icon-download',
              size='small',
              circle,
              @click.native='handleDownloadInvoice')
              | {{ $t('invoices.buttons.download_invoices') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import router from '@/router/index'
import B2bFiltersDeliveryNotesEmit from '@/views/albaranes/emitidos/B2bFiltersDeliveryNotesEmit'
import B2bTableMenuDeliveryNotesEmit from '@/views/albaranes/emitidos/B2bTableMenuDeliveryNotesEmit'
import B2bTableSelectRows from '@/components/B2bTableSelectRows'
import filters from './filtros-delivery-notes-emit'
import moment from 'moment'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-table-delivery-notes-emit',
  mixins: [Utils],
  data () {
    return {
      // Tabla
      currentRow: {},
      multipleSelection: [],
      multipleSelectionIds: [],
      // Paginación
      currentPage: null,
      searchType: 'EMITTED'

    }
  },

  computed: {
    ...mapGetters([
      'deliveryNotesEmit',
      'queryDeliveryNotesEmit',
      'isShowBuyerDeliveryNoteEmit',
      'isShowNumDeliveryNoteEmit',
      'isShowDateCreationDeliveryNoteEmit',
      'isShowDeliveryDateDeliveryNoteEmit',
      'isShowStatusDeliveryNoteEmit',
      'isShowSellerDeliveryNoteEmit',
      'isShowCentroVendedorDeliveryNoteEmit',
      'isShowCentroCompradorDeliveryNoteEmit',
      'isShowCentroEntregaDeliveryNoteEmit',
      'isShowServiceDeliveryNoteEmit',
      'isShowDateIssueDeliveryNoteEmit',
      'urlIn',
      'getActiveLang',
      'canViewDistributionCentres',
      'canCreateInvoiceDeliveryNote',
      'canAdminUser',
      'canViewDesadvMetadata',
      'canViewDesadvOriginal'
    ])
  },

  components: {
    B2bFiltersDeliveryNotesEmit,
    B2bTableMenuDeliveryNotesEmit,
    B2bTableSelectRows
  },

  methods: {
    ...mapActions([
      'getOptionsService',
      'getDeliveryNotes',
      'queryDeliveryNotesEmitState',
      'createDeliveryNoteState',
      'downloadDeliveryCsv',
      'handleDownloadMultiDeliveryNotesPdf',
      'downloadDeliveryNotePdf',
      'downloadDeliveryNoteDraftPdf',
      'downloadDeliveryOriginal',
      'downloadDeliveryMetadata',
      'downloadDeliveryNoteLabels',
      'createInvoiceState',
      'deleteDeliveryNote',
      'optionsFilterServiceState'
    ]),

    // Borrar albarán recibido con estado PENDING_OF_SEND
    async handleDelete () {
      this.$confirm(this.$t('new_deliveryNote.new_deliveryNote_form.notify.delete_deliveryNote'), {
        confirmButtonText: this.$t('new_deliveryNote.new_deliveryNote_form.notify.confirm_delete_deliveryNote'),
        showCancelButton: false,
        center: true,
        iconClass: 'ods-icon-warning'
      }).then(async () => {
        const load = this.$loading({
          lock: true,
          text: this.$t('new_deliveryNote.new_deliveryNote_form.load.delete_load_deliveryNote')
        })
        try {
          if(this.currentRow.id && this.currentRow.id!='_blank') { // eslint-disable-line
            const dataQuery = {
              deliveryNoteId: this.currentRow.id
            }
            await this.deleteDeliveryNote(dataQuery)
            this.$notify({
              title: this.$t('new_deliveryNote.new_deliveryNote_form.notify.delete_deliveryNote_ok'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          }
        } catch (error) {
          console.log('removeDeliveryNote CATCH: ', error)
        } finally {
          console.log('Obtenemos los albaranes de nuevo ')
          const dataQuery = {
            query: {}
          }
          dataQuery.query = this.queryDeliveryNotesEmit
          const result = await this.getDeliveryNotes(dataQuery)
          console.log('Delivery notes::::despues de eliminar ', result)
          load.close()
        }
      }).catch(() => {})
    },

    // Ordenar Tabla
    async orderOnServer ({ column, order, prop }) {
      let stringSort = ''
      const dataQuery = {
        query: {}
      }
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.order_table')
      })

      if (order === 'descending') {
        order = 'DESC'
      } else if (order === 'ascending') {
        order = 'ASC'
      } else {
        order = 'ASC'
      }

      if (!prop) {
        prop = 'creationDateTime'
      } else {
        switch (prop) {
          case 'buyerName':
            prop = 'partyByIdBuyer.tradeName'
            break
          case 'sellerName':
            prop = 'partyByIdSeller.tradeName'
            break
          case 'centreBuyer':
            prop = 'centreBuyer.centreCode'
            break
          case 'centreBuyerDeliveryPoint':
            prop = 'centreDeliveryPoint.centreCode'
            break
          case 'centreSeller':
            prop = 'centreSeller.centreCode'
            break
          case 'status':
            prop = 'statusDocument.status'
            break
          case 'issueDateTime':
            prop = 'issueDate'
            break
        }
      }

      stringSort = prop + ',' + order
      this.queryDeliveryNotesEmit.sort = stringSort

      try {
        if (this.urlIn && this.urlIn !== 'b2b') {
          this.queryDeliveryNotesEmit.urlName = this.urlIn
        } else {
          this.queryDeliveryNotesEmit.urlName = null
        }
        await this.queryDeliveryNotesEmitState(this.queryDeliveryNotesEmit)
        dataQuery.query = this.queryDeliveryNotesEmit
        const result = await this.getDeliveryNotes(dataQuery)
        console.log('Delivery notes:::: ', result)
      } catch (error) {
        console.log('orderOnServer CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    // Descargar todos a CSV
    async handleDownloadAllCsvEmitted () {
      if (this.deliveryNotesEmit.totalDeliveryNotesEmit > 120000) {
        this.$notify({
          title: this.$t('deliverynote.delivery_entity_table.csv_title'),
          message: this.$t('deliverynote.delivery_entity_table.csv_message', { argumento: '120.000' }),
          type: 'Warning',
          iconClass: 'ods-icon-warning',
          position: 'top-right',
          customClass: 'b2b-notification-info',
          duration: 10000
        })
      } else {
        const load = this.$loading({
          lock: true,
          text: this.$t('msg_generics.download_csv')
        })
        const params = this.queryDeliveryNotesEmit

        try {
          params.activeLang = this.getActiveLang
          params.isDetails = false
          const filename = await this.downloadDeliveryCsv(params)
          this.$notify({
            title: this.$t('msg_generics.download_file_ok', { filename: filename }),
            type: 'success',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })
        } catch (error) {
          console.log('handleDownloadAllCsvEmitted CATCH: ', error)
          this.getNotificationErrorMessage(error)
        } finally {
          load.close()
        }
      }
    },

    // Descargar todos a CSV con detalles lineas
    async handleDownloadCsvDetails () {
      if (this.deliveryNotesEmit.totalDeliveryNotesEmit > 100) {
        console.log(this.deliveryNotesEmit.totalDeliveryNotesEmit)
        this.$notify({
          title: this.$t('deliverynote.delivery_entity_table.csv_title'),
          message: this.$t('deliverynote.delivery_entity_table.csv_details_message'),
          type: 'Warning',
          iconClass: 'ods-icon-warning',
          position: 'top-right',
          customClass: 'b2b-notification-info',
          duration: 10000
        })
      } else {
        const load = this.$loading({
          lock: true,
          text: this.$t('msg_generics.download_csv')
        })

        const params = this.queryDeliveryNotesEmit
        try {
          params.activeLang = this.getActiveLang
          params.isDetails = true
          const filename = await this.downloadDeliveryCsv(params)

          this.$notify({
            title: this.$t('msg_generics.download_file_ok', { file: filename }),
            type: 'success',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })
        } catch (error) {
          this.getNotificationErrorMessage(error)
        } finally {
          load.close()
        }
      }
    },

    // Descargar etiquetas del albarán
    async handleDownloadLabels (delivery) {
      console.log('handleDownloadLabels: ', delivery.id)
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_pdf')
      })
      try {
        const params = {
          deliveryId: delivery.id,
          searchType: this.searchType
        }
        const filename = await this.downloadDeliveryNoteLabels(params)
        this.$notify({
          title: this.$t('msg_generics.download_file_ok', { filename: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    // Conseguir datos de la fila en el hover del ratón
    handleCellMouseEnter (row, column, cell, event) {
      this.currentRow = row
    },

    // Selección de Filas con el checkbox
    handleSelectionChange (val) {
      this.multipleSelection = val
      if (val.length === 0) {
        this.multipleSelection = []
      }
      this.multipleSelectionIds = this.multipleSelection.map(item => item.id)
    },

    // Ir al detalle
    async handleGoDetail (invoice) {
      if (this.currentRow.status && this.currentRow.status === 'PENDING_OF_SEND') {
        const deliveryNote = {
          draftId: this.currentRow.id
        }
        await this.createDeliveryNoteState(deliveryNote)
        router.push({ name: 'creacion-albaran-pedidos-recibidos', query: { type: 'ORDER_RECEIVED' } })
      } else {
        sessionStorage.setItem('deliveryNumber', this.currentRow.deliveryNumber)
        router.push({
          name: 'delivery-note-emit-detail',
          params: {
            deliveryId: this.currentRow.id,
            deliveryNumber: this.currentRow.deliveryNumber
          }
        })
      }
    },
    async handleDownloadOriginal (delivery) {
      this.handleCellMouseEnter(delivery)
      console.log('handleDownloadOriginal: ', delivery.id)
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_invoice_original')
      })
      try {
        const params = {
          deliveryId: delivery.id,
          searchType: this.searchType
        }
        const filename = await this.downloadDeliveryOriginal(params)
        this.$notify({
          title: this.$t('msg_generics.download_file_ok', { filename: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        console.log('handleDownloadOriginal CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    async handleDownloadMetadata (delivery) {
      this.handleCellMouseEnter(delivery)
      console.log('handleDownloadMetadata: ', delivery.id)
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_metadata')
      })
      try {
        const params = {
          deliveryId: delivery.id,
          searchType: this.searchType
        }
        const filename = await this.downloadDeliveryMetadata(params)
        this.$notify({
          title: this.$t('msg_generics.download_metadata_ok', { filename: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        console.log('handleDownloadMetadata CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    // Creación de una factura
    async handleCreateInvoice (delivery) {
      if (delivery.id && delivery.id !== 'creacion') {
        const invoice = {
          deliveryId: delivery.id
        }
        await this.createInvoiceState(invoice)
        router.push({ name: 'creacion-factura-albaranes-emitidos', query: { type: 'DELIVERYNOTE_EMIT' } })
      }
    },

    formatterTooltipInvoiceStatus (row, column) {
      if (row.messageStatus && row.messageStatus !== '') return this.formatterInvoiceStatus(row, column) + ' - ' + row.messageStatus
      else return this.formatterInvoiceStatus(row, column)
    },

    // Formatear estado de la factura
    formatterInvoiceStatus (row, column) {
      return this.$t('deliverynote_status.' + row[column.property])
    },

    // Formatear fechas Tabla
    formatterDate (row, column) {
      if (row[column.property]) {
        const date = moment(row[column.property])
        if (column.property === 'creationDateTime' || column.property === 'deliveryDate') {
          return date.format(this.$t('date_format_long'))
        } else {
          return date.format(this.$t('date_format'))
        }
      }
    },

    // JSX Menu Tabla
    renderHeaderActions: h => {
      return <B2bTableMenuDeliveryNotesEmit />
    },

    // Tamaño Tabla (20,50,100)
    async handleSizeChange (val) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.size_table')
      })
      try {
        const dataQuery = { query: {} }
        this.queryDeliveryNotesEmit.size = val
        if (this.urlIn && this.urlIn !== 'b2b') {
          this.queryDeliveryNotesEmit.urlName = this.urlIn
        } else {
          this.queryDeliveryNotesEmit.urlName = null
        }
        await this.queryDeliveryNotesEmitState(this.queryDeliveryNotesEmit)
        dataQuery.query = this.queryDeliveryNotesEmit
        await this.getDeliveryNotes(dataQuery)
      } catch (error) {
        console.log('handleSizeChange CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    // Paginacion
    async handleCurrentChangePagination (val) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.pagination_table')
      })

      try {
        const dataQuery = { query: {} }
        this.queryDeliveryNotesEmit.page = val - 1
        if (this.urlIn && this.urlIn !== 'b2b') {
          this.queryDeliveryNotesEmit.urlName = this.urlIn
        } else {
          this.queryDeliveryNotesEmit.urlName = null
        }
        await this.queryDeliveryNotesEmitState(this.queryDeliveryNotesEmit)
        dataQuery.query = this.queryDeliveryNotesEmit
        const results = await this.getDeliveryNotes(dataQuery)
        console.log('Delivery notes:::: ', results)
      } catch (error) {
        console.log('handleCurrentChangePagination CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    // Descarga de pdf
    async handleDownloadDeliveryNotePdf () {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_pdf')
      })
      try {
        let filename
        if (this.currentRow.status && this.currentRow.status === 'PENDING_OF_SEND') {
          filename = await this.downloadDeliveryNoteDraftPdf(this.currentRow.id)
        } else {
          const params = {
            deliveryId: this.currentRow.id,
            searchType: this.searchType
          }
          filename = await this.downloadDeliveryNotePdf(params)
        }
        this.$notify({
          title: this.$t('order.order_detail.notify.download_pdf', { file: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    // Seleccionadas
    async handleDownloadPdf () {
      const paramsValues = this.multipleSelectionIds.filter((item, index, self) => {
        return index === self.indexOf(item)
      })
      const load = this.$loading({
        lock: true,
        text: this.$t('invoices.loading.download_invoices')
      })
      console.log('handleDownloadInvoice() VALUES ->', paramsValues)
      try {
        const filename = await this.handleDownloadMultiDeliveryNotesPdf(paramsValues)
        this.$notify({
          title: this.$t('msg_generics.download_file_ok', { filename: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        console.log('handleDownloadInvoice CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null

      statusCode = error ? error.status : 0
      switch (statusCode) {
        case 400:
          errorSms = error.data.message
          break
        case 401:
          errorSms = this.$i18n.messages.es.error.e401

          break
        case 403:
          errorSms = this.$i18n.messages.es.error.e403
          break
        case 404:
        case 500:
          errorSms = error.data.message
          if (errorSms === undefined && error.config.responseType === 'blob') {
            errorSms = this.$t('msg_generics.error_download_not_found')
          }
          break
        case 409:
          errorSms = error.data.message
          break
        default:
          errorSms = this.$i18n.messages.es.error.default
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    }
  },

  async created () {
    const load = this.$loading({
      lock: true,
      text: this.$t('msg_generics.load_init')
    })
    try {
      const dataQuery = { query: {} }
      this.options = filters.filters
      const dataQueryProj = { page: 0, size: 1000, sort: 'name,ASC', isSender: true }
      const optionsFilterService = await this.getOptionsService(dataQueryProj)
      await this.optionsFilterServiceState(optionsFilterService)

      if (optionsFilterService.length === 1) {
        this.queryDeliveryNotesEmit.projectId = optionsFilterService[0].id
      }
      this.currentPage = this.queryDeliveryNotesEmit.page + 1
      if (this.urlIn && this.urlIn !== 'b2b') {
        this.queryDeliveryNotesEmit.urlName = this.urlIn
      } else {
        this.queryDeliveryNotesEmit.urlName = null
      }
      dataQuery.query = this.queryDeliveryNotesEmit
      const response = await this.getDeliveryNotes(dataQuery)
      console.log('response', response)
    } catch (error) {
      console.log('getDeliveryNotes CATCH: ', error)
      this.getNotificationErrorMessage(error)
    } finally {
      load.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.b2b-table-delivery-notes-emit {
  ::v-deep .ods-table {
    th {
      padding: rem(0);
      padding-top: rem(4);

      .cell {
        font-weight: 500;
      }
      .ods-dropdown{
        padding-left: 0px;
        padding-right: 0px;
      }

      &:last-child {
        padding-top: rem(0);
        .cell {
          .ods-dropdown {
            line-height: 32px;
          }
        }
      }
      .cell:last-child {
        .ods-dropdown {
          line-height: 32px;
        }
      }
    }
    &__row {
      .cell {
        .text-overflow-tooltip {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .ods-button {
        padding: rem(1) rem(15) rem(0) rem(15);
        margin-left: rem(0);
        margin-right: rem(0);
        i {
          margin-left: rem(0);
        }
      }
    }
  }

  ::v-deep &__pagination {
    margin: rem(32) rem(24) rem(32) rem(24);
    &--left {
      .ods-button {
        font-size: 0.625rem;
        line-height: 1.4;
        letter-spacing: .04rem;
        text-align: center;
        i {
          &:before {
            font-size: 0.625rem;
          }
        }
      }
    }
    &--right {
      .ods-pagination {
        justify-content: flex-end;
        width: auto;
        padding-top: rem(0);
        float: right;
        &__label {
          padding-top: rem(0);
          float: right
        }
      }
    }
  }

  ::v-deep .ods-col {
    min-width: 80px;
  }

}
</style>
